export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11891.45ea201a.jpg";